export const NAV = [
  { href: "/le-club", label: "Le club" },
  { href: "/stands", label: "Stands" },
  { href: "/initiation", label: "Initiation" },
  { href: "/locations", label: "Locations" },
  { href: "/rejoindre", label: "Nous rejoindre" },
] as const;

export const IMG = {
  hero: "/images/hero-operator.png",
  pistol: "/images/pistol-stance.png",
  sights: "/images/sights-close.png",
  team: "/images/team-cqb.png",
  range: "/images/range-lanes.png",
  silhouette: "/images/silhouette-line.png",
  carbine: "/images/carbine-kneel.png",
  action: "/images/action-move.png",
  indoor: "/images/stand-indoor.png",
  stand50: "/images/stand-50.png",
  arme9: "/images/arme-9mm.png",
  armePcc: "/images/arme-pcc.png",
  armeAr: "/images/arme-ar.png",
  armeRev: "/images/arme-revolver.png",
  arme45: "/images/arme-45.png",
  arme22: "/images/arme-22.png",
  logo: "/images/logo-sto.png",
};

export const GALLERY = [
  { src: IMG.hero, caption: "Opérateur · carabine", pos: "center 20%" },
  { src: IMG.action, caption: "Mouvement · 50 m", pos: "center" },
  { src: IMG.team, caption: "Binôme", pos: "center 30%" },
  { src: IMG.pistol, caption: "Stance poing", pos: "center 15%" },
  { src: IMG.carbine, caption: "À genou", pos: "center 25%" },
  { src: IMG.sights, caption: "Visée", pos: "center 20%" },
  { src: IMG.indoor, caption: "Stand indoor", pos: "center" },
  { src: IMG.stand50, caption: "Ligne 50 m", pos: "center" },
  { src: IMG.silhouette, caption: "Ligne de feu", pos: "center" },
  { src: IMG.armePcc, caption: "PCC 9 mm", pos: "center 20%" },
];

export const STANDS = [
  {
    slug: "10m",
    dist: "10 m",
    tag: "Indoor",
    image: IMG.pistol,
    pos: "center 18%",
    lead: "Nouvel espace. 3 postes à 10 mètres, collés au stand 20 m.",
    body: "Stand indoor dédié à la précision courte. Idéal pour le 10 m sportif et la prise en main en toute maîtrise.",
    specs: ["3 postes", "Indoor", "À côté du 20 m"],
  },
  {
    slug: "20m",
    dist: "20 m",
    tag: "Indoor · armes de poing",
    image: IMG.indoor,
    pos: "center",
    lead: "9 postes mécanisés. Acoustique et extraction d’air neuves.",
    body: "Stand 20 m entièrement rénové, éclairage LED, alarme sonore et visuelle, vidéo sécurisée. Dédié aux calibres d’armes de poing.",
    specs: [
      "9 postes mécanisés individuels",
      "Armes de poing",
      "Alarme + LED + vidéo",
      "Plomb / alliage cuivreux uniquement",
    ],
  },
  {
    slug: "25m",
    dist: "25 m",
    tag: "Semi-indoor · poing & pump",
    image: IMG.range,
    pos: "center 40%",
    lead: "2 × 5 postes mécanisés. Poing et pump.",
    body: "Le stand d’initiation et d’entraînement 25 m. Même exigence de maîtrise : tout impact hors cible peut engendrer des frais.",
    specs: [
      "2 × 5 postes mécanisés",
      "Armes de poing et pump",
      "Alarme + LED + vidéo",
      "Plomb / alliage cuivreux uniquement",
    ],
  },
  {
    slug: "50m",
    dist: "50 m",
    tag: "Semi-indoor · épaule",
    image: IMG.stand50,
    pos: "center",
    lead: "10 postes. Arrêts à 35, 40, 45 et 50 m. Jusqu’à 7000 J.",
    body: "Armes d’épaule, tous calibres, énergie max 7000 joules. Mécanisé, sécurisé, conçu pour la carabine comme pour le travail de précision longue.",
    specs: [
      "10 postes mécanisés",
      "Arrêts 35 / 40 / 45 / 50 m",
      "Énergie max 7000 J",
      "Plomb / alliage cuivreux uniquement",
    ],
  },
];

export const ARMES = [
  {
    id: "p22",
    name: "Pistolet sport",
    calibre: ".22 LR",
    type: "Poing",
    stand: "10 / 25 m",
    image: IMG.arme22,
    pos: "center 20%",
    text: "Prise en main, précision, initiation. Recul quasi nul.",
  },
  {
    id: "p9",
    name: "Pistolet service",
    calibre: "9 mm",
    type: "Poing",
    stand: "20 / 25 m",
    image: IMG.arme9,
    pos: "center 25%",
    text: "Le calibre de référence. Stance, visée, enchaînements.",
  },
  {
    id: "p9c",
    name: "Pistolet compact",
    calibre: "9 mm",
    type: "Poing",
    stand: "20 / 25 m",
    image: IMG.pistol,
    pos: "center 12%",
    text: "Format compact, même exigence de maîtrise.",
  },
  {
    id: "rev38",
    name: "Revolver",
    calibre: ".38 Sp",
    type: "Poing",
    stand: "20 / 25 m",
    image: IMG.armeRev,
    pos: "center 30%",
    text: "Double action, mécanique nue. École de trigger.",
  },
  {
    id: "p45",
    name: "Pistolet 1911",
    calibre: ".45 ACP",
    type: "Poing",
    stand: "25 m",
    image: IMG.arme45,
    pos: "center",
    text: "Simple action, recul franc, culture stand.",
  },
  {
    id: "pump",
    name: "Pump",
    calibre: "Poing / pump",
    type: "Poing",
    stand: "25 m",
    image: IMG.carbine,
    pos: "center 30%",
    text: "Stand 25 m. Manœuvre, rythme, sécurité d’abord.",
  },
  {
    id: "pcc",
    name: "Ruger PC Carbine",
    calibre: "9 mm",
    type: "Épaule",
    stand: "25 / 50 m",
    image: IMG.armePcc,
    pos: "center 22%",
    text: "Nouvelle au parc. Semi-auto, chargeurs Ruger / Glock, recul bas.",
    nouveau: true,
  },
  {
    id: "c22",
    name: "Carabine sport",
    calibre: ".22 LR",
    type: "Épaule",
    stand: "50 m",
    image: IMG.sights,
    pos: "center 18%",
    text: "Précision longue, coût de tir bas, travail de visée.",
  },
  {
    id: "ar223",
    name: "Carabine .223",
    calibre: ".223 Rem",
    type: "Épaule",
    stand: "50 m",
    image: IMG.armeAr,
    pos: "center",
    text: "Plateforme moderne. Énergie dans la limite des 7000 J.",
  },
  {
    id: "ak762",
    name: "Carabine 7.62",
    calibre: "7.62×39",
    type: "Épaule",
    stand: "50 m",
    image: IMG.action,
    pos: "center 35%",
    text: "Épaule, calibre intermédiaire, stand 50 m mécanisé.",
  },
  {
    id: "hero-c",
    name: "Carabine opérateur",
    calibre: ".223 Rem",
    type: "Épaule",
    stand: "50 m",
    image: IMG.hero,
    pos: "center 18%",
    text: "Travail d’épaule, optique, tenue de ligne.",
  },
  {
    id: "tld",
    name: "Épaule 50 m",
    calibre: "Tous calibres*",
    type: "Épaule",
    stand: "35 à 50 m",
    image: IMG.stand50,
    pos: "center",
    text: "Arrêts 35 / 40 / 45 / 50 m. *Énergie max 7000 J. Plomb ou cuivreux.",
  },
];

export const HORAIRES = [
  { day: "Lundi", hours: "18h — 21h" },
  { day: "Mardi", hours: "18h — 21h" },
  { day: "Mercredi", hours: "14h — 17h" },
  { day: "Jeudi", hours: "18h — 21h" },
  { day: "Vendredi", hours: "18h — 21h" },
  { day: "Samedi", hours: "14h — 17h" },
  { day: "Dimanche", hours: "9h — 12h" },
];

export const COMITE = [
  { role: "Président", name: "Laurent Bassi" },
  { role: "Vice-président", name: "Fabrice Lieber" },
  { role: "Trésorier", name: "Loïc Zeller" },
  { role: "Secrétaire", name: "Maxime Koerckel" },
];

export const MEMBRES = [
  "Michel Szygula",
  "Grégoire Kohler",
  "Didier Sergent",
  "Rémy Sergent",
  "Vincent Suntokeesing",
  "Loïc Bisch",
  "Alexandre Lalli",
  "Alexandre Rieffel",
  "Alban Moog",
  "Julien Nicola",
  "Tanguy De Jans",
];

export const NEWS = [
  {
    slug: "ruger-pc-carbine",
    date: "16 novembre 2025",
    title: "Ruger PC Carbine 9 mm à la location",
    excerpt:
      "Le STO renouvelle son parc : carabine semi-auto 9 mm, héritière de la Police Carbine, compatible chargeurs Ruger et Glock.",
    image: IMG.armePcc,
  },
  {
    slug: "concours-13-juin",
    date: "Samedi 13 juin",
    title: "Concours de tir STO",
    excerpt: "Le club vous invite à son concours. Inscriptions auprès du comité. Esprit sportif, stands mécanisés.",
    image: IMG.team,
  },
  {
    slug: "stop-the-bleed",
    date: "Novembre",
    title: "Première formation Stop the Bleed",
    excerpt:
      "La Société de Tir d’Ostwald a accueilli sa première formation Stop the Bleed, animée au sein du club.",
    image: IMG.indoor,
  },
];

export const PARTENAIRES = [
  "Adam Boissons",
  "Resilians",
  "Armurerie Buffenoir",
  "Crédit Mutuel",
  "B2OS",
  "AXA agence Mejias Morel",
  "Le Fourgon",
  "Oh So Clean !",
];

export const CALIBRES = [".22 LR", "9 mm", ".38 Sp", ".45 ACP", ".223 Rem", "7.62×39"];

export const MARQUEE = [
  "10 m",
  "20 m",
  "25 m",
  "50 m",
  "Safe & protect",
  "FFTir",
  "Ostwald",
  "Depuis 1970",
];

export const CONTACT = {
  phone: "06 17 66 23 95",
  phoneHref: "tel:+33617662395",
  email: "sto_tir@yahoo.com",
  address: "Quai Olida — Zone omnisports",
  city: "67540 Ostwald",
  shop: "https://stostwald.tunetoo.com/",
};
